import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionButton from "components/common/ActionButton";
import IconButton from "components/common/IconButton";
import AdvanceTablePagination from "components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import { deleteUser, getUsers } from "functions/user";
import { useEffect, useState, useContext } from "react";
import { Button, Card, Col, Dropdown, FormControl, InputGroup, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AllTicketsHeader from "./AllTicketsHeader";
import { useBreakpoints } from "hooks/useBreakpoints";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import DeleteConfirm from "components/dialogBoxes/DeleteConfirm";
import { toast } from "react-toastify";
import MessageBox from "components/dialogBoxes/MessageBox";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import AppContext from 'context/Context';



const ListUsers=()=>{
    const { config } = useContext(AppContext);
    const { isDark } = config;
    const textColor = isDark ? '#fff' : '#212529';
    const tableBg = isDark ? undefined : '#fff';

    const [users,setUsers]=useState([]);
    const [isTicketLoading, setIsTicketLoading] = useState(false);

    const [userData,setUserData]=useState(null);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [message, setMessage] = useState(null);

    useEffect(()=>{
      const _userData=JSON.parse(localStorage.getItem('userData'));
      setUserData(_userData);
    console.log('userData',_userData);
    
    },[])
   

    const loadUsers = async () => {
      try {
  
        const token=localStorage.getItem('token');
    
        setIsTicketLoading(true);
   
       const res = await getUsers(token);
       console.log('loadUsers recordset ', res)
  
        const usersArr = [];
  
        res &&
        res.map(r => {
              const address=`${r.No} ${r.City} ${r.District} ${r.PostalCode}`;
  
            usersArr.push({
              id: r.UserId,
              isActive:r.IsActive,
              userName:r.UserName,
              email:r.Email,
              displayName:r.ContactPerson,
              address:address,
              country:r.Country,
              telNo:r.TelNo,
              mobNo:r.MobNo,
              workTel:r.WorkTel,
              comment:r.Comment,
              umt:r.UMT,
              gmt:r.GMT_Offset,
              roleName:r.RoleName,
              modified:r.UpdatedDateTime,
              designation: r.Designation
              // avatar: {
              //   name: r.Client,
              //   size: 'xl',
              //   round: 'circle'
              // },
            });
          });
          setIsTicketLoading(false);
  
          setUsers(usersArr);
          console.log('usersArr', usersArr);
      } catch (err) {
        console.log('Error', err);
      }
    };
  

    const navigate = useNavigate();
  
    useEffect(() => {
      loadUsers();
     },[]);
   

const columns = [
  {
    accessor: 'userName',
    Header: 'User Name',
    headerProps: { style: { minWidth: '4.625rem' ,color: textColor} },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { userName,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{userName}</p>
      );
    }
  },
  {
    accessor: 'email',
    Header: 'Email',
    headerProps: { style: { minWidth: '4.625rem', color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { email,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{email}</p>
      );
    }
  },
  // {
  //   accessor: 'gmt',
  //   Header: 'GMT',
  //   headerProps: { style: { minWidth: '4.625rem' } },
  //   cellProps: {
  //     className: 'py-2 pe-4'
  //   },
  //   Cell: rowData => {
  //     const { gmt,id } = rowData.row.original;
  //     return (
  //       <p>
  //         {gmt}
  //       </p>
  //     );
  //   }
  // },
  // {
  //   accessor: 'tel',
  //   Header: 'Tel',
  //   headerProps: { style: { minWidth: '4.625rem' } },
  //   cellProps: {
  //     className: 'py-2 pe-4'
  //   },
  //   Cell: rowData => {
  //     const { tel,id } = rowData.row.original;
  //     return (
  //       <p>
  //         {tel}
  //       </p>
  //     );
  //   }
  // },

  {
    accessor: 'mobNo',
    Header: 'Mobile',
    headerProps: { style: { minWidth: '4.625rem' , color: textColor} },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { mobNo,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{mobNo}</p>
      );
    }
  },

  {
    accessor: 'workTel',
    Header: 'Work Tel',
    headerProps: { style: { minWidth: '4.625rem', color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { mobNo,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{mobNo}</p>
      );
    }
  },

  {
    accessor: 'designation',
    Header: 'Designation',
    headerProps: { style: { minWidth: '4.625rem', color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { designation,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{designation}</p>
      );
    }
  },

  {
    accessor: 'isActive',
    Header: 'Active',
    headerProps: { style: { minWidth: '4.625rem', color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { isActive } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{isActive ? 'Yes' : 'No'}</p>
      );
    }
  },
  
  {
    accessor: 'UserId',
    Header: 'Action',
    headerProps: { style: { minWidth: '4.625rem', color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { UserId,id } = rowData.row.original;
      return (
        <>
        <ActionButton icon="edit" title="Edit" variant="action" className="p-0 me-2" onClick={()=>{
                navigate(`/support-desk/add-user/${id}/U`);
        }} />
        <ActionButton icon="trash-alt" title="Delete" variant="action" className="p-0" onClick={()=>handleShowDialogDelete(id)} />
        </>
      );
    }
  },

];

const TableView = ({ exportUsersToExcel }) => {
  const [show, setShow] = useState(false);
  const { breakpoints } = useBreakpoints();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  
   //const [tickets,setTickets]=useState([]);

   const [skip,setSkip]=useState(null);
   const [limit,setLimit]=useState(null);
   const [isTicketLoading, setIsTicketLoading] = useState(false);



  return (
    <>
      <AdvanceTableWrapper
        columns={columns}
        data={users}
        selection
        selectionColumnWidth={52}
        sortable
        pagination
        perPage={11}
        rowCount={users.length}
      >
        <Card>
          <Card.Header className="border-bottom border-200 px-0" style={{ color: textColor, background: tableBg }}>
            <AllTicketsHeader
              table
              layout="table-view"
              handleShow={handleShow}
              exportUsersToExcel={exportUsersToExcel}
            />
          </Card.Header>
          <Card.Body className="p-0" style={{ background: tableBg }}>
            {isTicketLoading ? (
              <div className="p-5 d-flex align-items-center justify-content-center" style={{ color: textColor }}>
                <ItemsLoading1
                  animation="border"
                  size="sm"
                  message="Loading please wait..."
                />
              </div>
            ) : (
              <AdvanceTable
                table
                headerClassName="bg-light text-800 align-middle"
                rowClassName="btn-reveal-trigger align-middle"
                tableProps={{
                  size: 'sm',
                  className: 'fs--1 mb-0 overflow-hidden',
                  style: { color: textColor, background: tableBg },
                  children: [
                    <style key="table-white-text">{`
                      .table thead th, .table th {
                        color: ${isDark ? '#fff' : '#212529'} !important;
                        background: ${isDark ? '#23272b' : '#f8f9fa'} !important;
                      }
                      .table tbody td, .table tfoot td, .table td {
                        color: ${isDark ? '#fff' : '#212529'} !important;
                      }
                    `}</style>
                  ]
                }}
              />
            )}
          </Card.Body>
          <Card.Footer style={{ color: textColor, background: tableBg }}>
            <AdvanceTablePagination table />
          </Card.Footer>
        </Card>
      </AdvanceTableWrapper>
    </>
  );
};




const handleShowDialogDelete = (id) => {
  setUserIdToDelete(id);
  setShowDeleteConfirm(true);
};

const handleConfirmDelete =async () => {
  const token=localStorage.getItem('token');
  setShowDeleteConfirm(false);
 const res= await deleteUser(userIdToDelete, token);
 console.log(res.status,'user letetion res',res.data.error);

 if(res.status===400)
 setMessage({title:'Exception',message:res.data.error,variant:'danger'})

  setUserIdToDelete(null);
  loadUsers();
};

const handleCancelDelete = () => {
  setShowDeleteConfirm(false);
  setUserIdToDelete(null);
  console.log('Cancelled!');
};

const onMessageBoxCloseHandler=()=>{
  setMessage(null);
}

// Export all users to Excel with column widths and bold header
const exportUsersToExcel = () => {
  if (!Array.isArray(users) || users.length === 0) {
    alert('No users to export!');
    return;
  }
  const data = users.map(user => ({
    UserName: user.userName,
    Email: user.email,
    DisplayName: user.displayName,
    Address: user.address,
    Country: user.country,
    TelNo: user.telNo,
    MobNo: user.mobNo,
    WorkTel: user.workTel,
    Comment: user.comment,
    UMT: user.umt,
    GMT: user.gmt,
    Role: user.roleName,
    Modified: user.modified,
    Designation: user.designation,
    Active: user.isActive ? 'Yes' : 'No'
  }));
  const worksheet = XLSX.utils.json_to_sheet(data);
  // Set column widths for more space between columns
  worksheet['!cols'] = [
    { wch: 18 }, // UserName
    { wch: 28 }, // Email
    { wch: 22 }, // DisplayName
    { wch: 32 }, // Address
    { wch: 16 }, // Country
    { wch: 14 }, // TelNo
    { wch: 14 }, // MobNo
    { wch: 14 }, // WorkTel
    { wch: 20 }, // Comment
    { wch: 10 }, // UMT
    { wch: 10 }, // GMT
    { wch: 16 }, // Role
    { wch: 18 }, // Modified
    { wch: 18 }  // Designation
  ];
  // Optionally, make header row bold (works in some SheetJS builds)
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cell_address = XLSX.utils.encode_cell({ r: 0, c: C });
    if (!worksheet[cell_address]) continue;
    worksheet[cell_address].s = { font: { bold: true } };
  }
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
  const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(file, 'users.xlsx');
};


return (
  <>
    <Row className="gx-3">
      <Col xxl={12} xl={12}>
       
        <TableView exportUsersToExcel={exportUsersToExcel} />
      {showDeleteConfirm &&  <DeleteConfirm
          title="Confirm Delete"
          message="Do you want to confirm?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />}
 {message && <MessageBox onMessageBoxClose={onMessageBoxCloseHandler} title={message.title} message={message.message} variant={message.variant} />}
      </Col>
    </Row>
  </>
);

}

export default ListUsers;